import { NgModule, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import 'hammerjs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


// Providers
import { AuthGuard } from './_guards/auth.guard';
import { AlertService } from './_services/alert.service';
import { AuthenticationService } from './_services/authentication.service'
import { JWTUtil } from './_utils/jwt.util';


// Layout
import { LayoutComponent } from './layout/layout.component';
import { PreloaderDirective } from './layout/preloader.directive';
// Header
import { AppHeaderComponent } from './layout/header/header.component';
// Sidenav
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';
// Customizer
import { AppCustomizerComponent } from './layout/customizer/customizer.component';
import { ToggleQuickviewDirective } from './layout/customizer/toggle-quickview.directive';
// Footer
import { AppFooterComponent } from './layout/footer/footer.component';
// Search Overaly
import { AppSearchOverlayComponent } from './layout/search-overlay/search-overlay.component';
import { SearchOverlayDirective } from './layout/search-overlay/search-overlay.directive';
import { OpenSearchOverlaylDirective } from './layout/search-overlay/open-search-overlay.directive';

// Alert
import { AlertComponent } from './_directives/alert.component';

// Pages
import { DashboardComponent } from './dashboard/dashboard.component';


// Sub modules
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';

// hmr
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

//translate

import { TranslateModule, TranslateLoader, TranslateStaticLoader, TranslatePipe, TranslateDirective } from 'ng2-translate';
import { ToastyModule } from 'ng2-toasty';
import { InputSwitchModule } from 'primeng/primeng';
import { EasyMarineHttpFinances, easyMarineHttpFinancesCreator } from './_utils/easy-marine-http-finances';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FinancesService } from './_services/finances.service';
import { HttpsRequestInterceptor } from './_services/interceptor.module';
import { EasyMarineHttpClient, easyMarineHttpClientCreator } from './_utils/easy-marine-http-client';
import { Router } from '@angular/router';
import { ContractDocumentService } from './_services/contract-document.service';
import { ContractsBalanceComponent } from './dashboard/contracts-balance/contracts-balance.component';
import { TableModule } from 'primeng/table';
import { DocumentContractedMarinaService } from './_services/document-contracted-marina.service';
import { ContractsProcessingFileComponent } from './dashboard/contracts-balance/contracts-processing-file/contracts-processing-file.component';
import { ContractsProcessingSignatureComponent } from './dashboard/contracts-balance/contracts-processing-signature/contracts-processing-signature.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProductService } from './_services/product.service';
import { TicketsComponent } from './tickets/tickets.component';


@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        HttpModule,
        FormsModule,
        MaterialModule,
        BrowserAnimationsModule,
        TableModule,
        AppRoutingModule,
        InputSwitchModule,
        // Sub modules
        LayoutModule,
        SharedModule,
        ToastyModule.forRoot(),
        //translate
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            deps: [Http]
        }),
        NgxSpinnerModule,        
    ],
    declarations: [
        AppComponent,
        // Layout
        LayoutComponent,
        PreloaderDirective,
        // Header
        AppHeaderComponent,
        // Sidenav
        AppSidenavComponent,
        ToggleOffcanvasNavDirective,
        AutoCloseMobileNavDirective,
        AppSidenavMenuComponent,
        AccordionNavDirective,
        AppendSubmenuIconDirective,
        HighlightActiveItemsDirective,
        // Customizer
        AppCustomizerComponent,
        ToggleQuickviewDirective,
        // Footer
        AppFooterComponent,
        // Search overlay
        AppSearchOverlayComponent,
        SearchOverlayDirective,
        OpenSearchOverlaylDirective,
        //
        AlertComponent,
        DashboardComponent,
        ContractsBalanceComponent,
        ContractsProcessingFileComponent,
        ContractsProcessingSignatureComponent,
        TicketsComponent
        // Pages
    ],
    providers: [
        AuthGuard,
        AlertService,
        AuthenticationService,
        JWTUtil,
        FinancesService,        
        ProductService,
        ContractDocumentService,
        { provide: EasyMarineHttpFinances, useFactory: easyMarineHttpFinancesCreator, deps: [HttpClient] },
        { provide: EasyMarineHttpClient, useFactory: easyMarineHttpClientCreator, deps: [HttpClient, Router] }
        
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
    constructor(public appRef: ApplicationRef) { }
    hmrOnInit(store) {
        console.log('HMR store', store);
    }
    hmrOnDestroy(store) {
        const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
        // recreate elements
        store.disposeOldHosts = createNewHosts(cmpLocation);
        // remove styles
        removeNgStyles();
    }
    hmrAfterDestroy(store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts